import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from "../../app.component";
import {NavigationEnd, Router} from "@angular/router";

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./my-account.component.less']
})
export class MyAccountComponent implements OnInit {
  global_texts: any = null;

  constructor(
    public app: AppComponent, private router: Router
  ) {
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     this.initializeComponentAccount();
    //   }
    // });
  }

  ngOnInit(): void {
    this.initializeComponentAccount();
  }

  initializeComponentAccount() {
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      this.global_texts = texts;
    });
  }

}
